import { type VariantChoice } from "../__app.collect.orders.create/orders-create-context";

import type { ProductFormData } from "./route";

export function parseVariantFormData(
  variantData: ProductFormData["variants"]
): VariantChoice[] {
  if (!variantData) return [];

  const choices: VariantChoice[] = [];

  for (const [variantId, choice] of Object.entries(variantData)) {
    if (!choice) continue;

    for (const [choiceId, quantity] of Object.entries(choice)) {
      if (quantity > 0) {
        choices.push({ id: choiceId, variantId, quantity });
      }
    }
  }

  return choices;
}
